import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MarkSuccessOnClick } from '@justgiving/experiments';
import { Button } from '@justgiving/react-tracking';

import { Experiments } from '../../constants/experiments';
import {
  MessageOverrides,
  usePageMeta,
  usePageOwner,
  useShareUrls,
} from '../../hooks';
import { ShareModal } from '../ShareModal/ShareModal';

import styles from './Share.scss';

interface ShareProps {
  successType: string;
  shareUrl?: string;
  messageOverrides?: MessageOverrides;
}

export const Share: FunctionComponent<ShareProps> = ({
  successType,
  shareUrl,
  messageOverrides,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const [isOpen, setOpen] = useState(false);
  const shareUrls = useShareUrls(shareUrl, messageOverrides);
  const { isPageOwner, data: pageOwnerData } = usePageOwner();
  const { pageType } = usePageMeta();

  const shareModalHeading = isPageOwner
    ? t('shareModal.heading.pageOwner')
    : t('shareModal.heading', {
        pageOwner: pageOwnerData?.owner?.name,
      });

  const keyValues = {
    pageType,
  };

  return (
    <>
      <MarkSuccessOnClick
        testSlug={Experiments.b2c_045_donate_button_color}
        successType={successType}
        keyValues={keyValues}
      >
        <MarkSuccessOnClick
          testSlug={Experiments.b2c_040_frp_trust_proposition_bar}
          successType={successType}
        >
          {/*// B2C_044 - donate to yourself*/}
          {/*// Remove this experiment when complete*/}
          <MarkSuccessOnClick
            testSlug={Experiments.b2c_044_donate_to_yourself}
            successType="GenericShareButtonClick"
          >
            {/*// B2C_048 - show hide fitness data*/}
            {/*// Can be removed when experiment has ended*/}
            {/*// or added as a non experiment test if successful*/}
            <MarkSuccessOnClick
              testSlug={Experiments.b2c_048_show_hide_fitness_data}
              successType="GenericShareButtonClick"
            >
              <Button
                className={`jg-btn ${styles.shareButton}`}
                onClick={() => setOpen(true)}
                type="button"
                trackingData={{
                  action_name: 'click',
                  subtype: 'share',
                  event: 'click',
                  event_value: 'share',
                }}
              >
                {t('common.share')}
              </Button>
            </MarkSuccessOnClick>
          </MarkSuccessOnClick>
        </MarkSuccessOnClick>
      </MarkSuccessOnClick>
      {isOpen && shareUrls ? (
        <ShareModal
          heading={shareModalHeading}
          description={t('shareModal.description')}
          onClose={() => setOpen(false)}
          shareItems={shareUrls}
        />
      ) : null}
    </>
  );
};
